export default __webpack_public_path__ + "static/media/video_karier.88675bd0.png";